import { AxiosBaseApi } from '@config/axios.config'
import { ENDPOINTS } from '@constants'
import { ISingleTag } from '@typings'
import { AxiosResponse } from 'axios'

export class TagsApi extends AxiosBaseApi {
  get_list = () =>
    this.api
      .get<AxiosResponse<{ data: ISingleTag[] }>>(ENDPOINTS.TAGS.LIST(), {
        params: { per_page: 9999999 },
      })
      .then(response => response.data.data)

  get_single = (id: ISingleTag['id']) =>
    this.api
      .get<AxiosResponse<{ data: ISingleTag }>>(ENDPOINTS.TAGS.SINGLE(id))
      .then(res => res.data.data)

  update = (
    id: ISingleTag['id'],
    data: {
      name: ISingleTag['name']
      category: ISingleTag['category']
    }
  ) => this.api.put(ENDPOINTS.TAGS.SINGLE(id), data).then(res => res)

  create = (data: {
    name: ISingleTag['name']
    category: ISingleTag['category']
  }) => this.api.post(ENDPOINTS.TAGS.LIST(), data).then(res => res)

  detach_customers = (id: ISingleTag['id'], customer_ids: number[]) =>
    this.api
      .delete(ENDPOINTS.TAGS.DETACH_CUSTOMERS(id), { data: { customers: customer_ids } })
      .then(res => res)

  detach_targeted_products = (id: ISingleTag['id'], product_ids: number[]) =>
    this.api
      .delete(ENDPOINTS.TAGS.DETACH_TARGETED_PRODUCTS(id), { data: { products: product_ids } })
      .then(res => res)

  attach_targeted_products = (id: ISingleTag['id'], product_ids: number[]) =>
    this.api
      .put(ENDPOINTS.TAGS.ATTACH_TARGETED_PRODUCTS(id), { products: product_ids })
      .then(res => res)

  attach_customers = (id: ISingleTag['id'], customer_ids: number[]) =>
    this.api
      .put(ENDPOINTS.TAGS.ATTACH_CUSTOMERS(id), { customers: customer_ids })
      .then(res => res)
}
